import PropTypes from 'prop-types';
import React from 'react';
import './toggle.scss';
import clsx from 'clsx';

const ToggleSizes = {
  SMALL: 'size-s',
  MEDIUM: 'size-m',
};

const Toggle = ({
  checked, disabled, onChange, size, className, label, hintText, inputProps,
}) => {
  const classNames = clsx('toggle-cont', { checked, disabled }, size, className);
  const elTabIndex = disabled ? -1 : 0;
  const { name, title, ariaLabel } = inputProps;

  const handleOnClick = () => {
    if (!disabled && typeof onChange === 'function') {
      onChange.call(null);
    }
  };

  // TODO: Move logic to custom useKeyPress hook
  const handleKeypress = (event) => {
    if (event.charCode === 13) {
      handleOnClick();
    }
  };

  return (
    <div className={classNames} onClick={handleOnClick} onKeyPress={handleKeypress}>
      <div className="toggle-switch-cont">
        <span
          className="toggle-switch"
          tabIndex={elTabIndex}
        >
          <input
            type="checkbox"
            checked={checked}
            disabled={disabled}
            readOnly
            aria-checked={checked}
            aria-label={ariaLabel}
            name={name}
            title={title}
          />
          <span className="switch" />
        </span>
      </div>
      { (label || hintText)
      && (
      <div className="toggle-label-cont">
        {label && (<div className="toggle-label">{label}</div>)}
        {hintText && (<div className="toggle-hint">{hintText}</div>)}
      </div>
      )}
    </div>
  );
};

Toggle.defaultProps = {
  checked: false,
  disabled: false,
  onChange: () => {},
  size: ToggleSizes.MEDIUM,
  className: '',
  label: '',
  hintText: '',
  inputProps: {},
};

Toggle.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  size: PropTypes.oneOf([ToggleSizes.SMALL, ToggleSizes.MEDIUM]),
  className: PropTypes.string,
  label: PropTypes.string,
  hintText: PropTypes.string,
  inputProps: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    ariaLabel: PropTypes.string,
  }),
};

export {
  Toggle as default,
  ToggleSizes,
};
